import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { OnboardingPhase } from '../../interfaces/onboarding.interfaces';

@Component({
    selector: 'fina-phase-completed-modal',
    templateUrl: './phase-completed-modal.component.html',
    styleUrls: ['./phase-completed-modal.component.scss'],
})
export class PhaseCompletedModalComponent {
    @Input() phase: OnboardingPhase | null = null;

    constructor(public activeModal: NgbActiveModal, private router: Router) {}

    get completedTaskCount(): number {
        return this.phase?.tasks?.filter(task => task.isCompleted).length || 0;
    }

    get totalTaskCount(): number {
        return this.phase?.tasks?.length || 0;
    }

    get mandatoryProgress(): number {
        return this.phase?.progress?.mandatory || 0;
    }

    get overallProgress(): number {
        return this.phase?.progress?.overall || 0;
    }

    keepExploring(): void {
        this.activeModal.close();
    }

    goToReports(): void {
        this.activeModal.close();
        this.router.navigate(['/financial-summary']);
    }
}
